<template>
    <div ref="content" style="width: 100%;height:100%;position: relative">
        <div :style="'height:'+height+'px'">
            <mt-loadmore :bottomDropText="options.bottomDropText" :bottomPullText="options.bottomPullText"
                         :top-method="loadTop" :bottom-method="loadBottom"
                         :bottom-all-loaded="!options.hasMore"
                         ref="loadmore">
                <div class="list">
                    <div @click="showDetail(item)" v-for="item in list" class="list-item space-between"
                         style="margin-top:1px;">
                        <div style="width:100px;height:80px;background: #f2f2f2;overflow: hidden">
                            <img style="width: 100%;height:100%" :src="item.headImgUrl"/>
                        </div>
                        <div style="margin-left: 10px;flex:1">
                            <div>{{item.title}}</div>

                        </div>
                        <img style="transform:scale(2)" src="../assets/img/next.svg"/>
                    </div>
                    <div class="border-line"></div>
                </div>
            </mt-loadmore>
        </div>
    </div>
</template>

<script>
    import api from "../api";
    import utils from "../common/utils";
    import {Indicator} from 'mint-ui';

    export default {
        data() {
            return {
                height: 0,
                options: {
                    currentPage: 1,
                    pageSize: 10,
                    hasMore: false,
                    bottomDropText: "释放加载",
                    bottomPullText: "加载更多",
                },
                list: []
            }
        },
        methods: {
            loadTop: function () {
                this.options.currentPage = 1;
                this.loadList((res) => {
                    this.$refs.loadmore.onTopLoaded();
                });
            },
            loadBottom: function () {
                this.options.loading = true;
                this.options.currentPage++;
                this.loadList((res) => {
                    this.$refs.loadmore.onBottomLoaded();
                });
            },
            loadList: function (onload) {
                Indicator.open('加载中...');
                window.Indicator = Indicator;
                api.getFormUrl(this, "yy/front/getActivity", {
                    pageNo: this.current,
                    pageSize: 15
                }, (res) => {
                    if (this.options.currentPage == 1) {
                        this.list = [];
                    }
                    this.list = this.list.concat(res.data || [])
                    if (res.total <= res.pageNo * res.pageSize) {
                        this.options.hasMore = false;
                        if (this.list.length) {
                            this.options.bottomPullText = "没有更多了";
                        } else {
                            this.options.bottomPullText = "没有数据";
                        }
                    } else {
                        this.options.hasMore = true;
                        this.options.bottomPullText = "加载更多";
                    }
                    onload(res);
                    Indicator.close();
                }, () => {
                    Indicator.close();
                })
            },
            showDetail: function (item) {
                this.$store.commit('set', {
                    transData: item.detail||"暂无活动详情"
                });
                this.$router.push({
                    path: '/textview',
                    query: {
                        YY_USER_ID: this.$route.query.YY_USER_ID,
                        openId: this.$route.query.openId || this.openId
                    }
                })
                // location.href = "/#/textview?YY_USER_ID=" + this.$store.state.YY_USER_ID
            },
            jumpTo: function (path) {
                this.$router.push({
                    path: path,
                    query: {
                        YY_USER_ID: this.$route.query.YY_USER_ID,
                        openId: this.$route.query.openId || this.openId
                    }
                })
            },
        },
        mounted() {

        }
    }

</script>

<style lang="scss">
    @import "../assets/styles/common.css";
</style>